import React, { useEffect } from "react"

const Udrew = () => {
  const widgetRef = React.useRef(null)
  const scriptSrc =
    "https://widget.wapilot.udrew.com.au/sales-widget/widget.js?mountId=udrew-widget&apiKey=AEO-1ac14658-0995-4237-9586-bb8d9c12e439&configId=41ff932030494891a6abdc01e7c13e9c&itemsId=My-Collection-2025.12.03-12.291764736188&region=AUSTRALIA&mode=full&initialSearch="

  useEffect(() => {
    // Use a small timeout to ensure DOM is ready and widget container exists
    let retryCount = 0
    const maxRetries = 10

    const initUdrew = () => {
      // Ensure widget container exists (using ref or getElementById)
      const widgetContainer =
        widgetRef.current || document.getElementById("udrew-widget")

      if (!widgetContainer && retryCount < maxRetries) {
        // Container not ready yet, try again
        retryCount++
        setTimeout(initUdrew, 50)
        return
      }

      if (!widgetContainer) {
        // Container still not found after retries, skip initialization
        return
      }

      // Remove existing script if present to ensure clean re-initialization
      const existingScript = document.querySelector(
        `script[src*='widget.wapilot.udrew.com.au']`
      )
      if (existingScript) {
        existingScript.remove()
      }

      // Add the script fresh to trigger initialization
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.src = scriptSrc
      script.defer = true
      document.body.appendChild(script)
    }

    // Small delay to ensure DOM is ready, especially on client-side navigation
    const timeoutId = setTimeout(initUdrew, 100)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [scriptSrc])

  return (
    <div
      ref={widgetRef}
      id="udrew-widget"
      style={{
        height: "1000px",
        maxHeight: "90vh",
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        border: "1px solid gray",
        background: "white",
        borderRadius: "20px",
        overflow: "hidden"
      }}
    />
  )
}

export default Udrew
